import { useContext } from "react";
import Tooltip from "@/Components/UI/Tooltip/Tooltip";
import { ThemeContext } from "@/context/ThemeContext/ThemeContext";

export const VolumeIncreaseIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative">
      <svg
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5857 24V21.1886C17.6429 20.5943 19.3 19.4514 20.5571 17.76C21.8143 16.0686 22.4429 14.1486 22.4429 12C22.4429 9.85143 21.8143 7.93143 20.5571 6.24C19.3 4.54857 17.6429 3.40571 15.5857 2.81143V0C18.42 0.64 20.7286 2.07429 22.5114 4.30286C24.2943 6.53143 25.1857 9.09714 25.1857 12C25.1857 14.9029 24.2943 17.4686 22.5114 19.6971C20.7286 21.9257 18.42 23.36 15.5857 24ZM0.5 16.1486V7.92H5.98571L12.8429 1.06286V23.0057L5.98571 16.1486H0.5ZM15.5857 17.52V6.48C16.66 6.98286 17.5 7.73714 18.1057 8.74286C18.7114 9.74857 19.0143 10.8457 19.0143 12.0343C19.0143 13.2 18.7114 14.28 18.1057 15.2743C17.5 16.2686 16.66 17.0171 15.5857 17.52Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const VolumeDecreaseIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="VolumeDecreaseIconId">
      <svg
        width="21"
        height="24"
        viewBox="0 0 21 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16.5V7.5H6L13.5 0V24L6 16.5H0ZM16.5 18V5.925C17.625 6.45 18.5312 7.2625 19.2188 8.3625C19.9062 9.4625 20.25 10.675 20.25 12C20.25 13.325 19.9062 14.525 19.2188 15.6C18.5312 16.675 17.625 17.475 16.5 18Z"
          fill={color}
        />
      </svg>

      <Tooltip id={"VolumeDecreaseIconId"} content={"Mute (only for you)"} />
    </div>
  );
};

export const PlayIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="PlayIconId">
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 20V0L15.7143 10L0 20Z" fill={color} />
      </svg>

      <Tooltip id={"PlayIconId"} content={"Play (only for you)"} />
    </div>
  );
};

export const PauseIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="PauseIconId">
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4286 20V0H17.1429V20H11.4286ZM0 20V0H5.71429V20H0Z"
          fill={color}
        />
      </svg>

      <Tooltip id={"PauseIconId"} content={"Pause (only for you)"} />
    </div>
  );
};

export const NextAudioIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="NextAudioIconId">
      <svg
        width="23"
        height="20"
        viewBox="0 0 23 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.8537 20V0H22.2462V20H18.8537ZM0.195312 20V0L15.4613 10L0.195312 20Z"
          fill={color}
        />
      </svg>

      <Tooltip id={"NextAudioIconId"} content={"Next"} />
    </div>
  );
};

export const PrevioustAudioIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="PrevioustAudioIconId">
      <svg
        width="23"
        height="20"
        viewBox="0 0 23 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 20V0H3.39244V20H0ZM22.0509 20L6.78488 10L22.0509 0V20Z"
          fill={color}
        />
      </svg>

      <Tooltip id={"PrevioustAudioIconId"} content={"Previous"} />
    </div>
  );
};

export const VolumeAnimatedIcon = () => (
  <span className="pulse">
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z" />
    </svg>
  </span>
);

export const VolumeXIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="VolumeXIconId">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="25"
        viewBox="0 0 576 512"
      >
        <path
          fill={color}
          d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        />
      </svg>

      <Tooltip id={"VolumeXIconId"} content={"Unmute (only for you)"} />
    </div>
  );
};

export const DeleteIcon = ({ id = "ID" }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div
      className="relative"
      data-tooltip-id={`DeleteIcon${id}`}
      style={{ top: "-2px" }}
    >
      <svg
        width="24"
        height="18"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.6064 17.2071L16.1666 19.6469C15.9312 19.8823 15.6316 20 15.2678 20C14.9039 20 14.6043 19.8823 14.3689 19.6469C14.1335 19.4114 14.0157 19.1118 14.0157 18.748C14.0157 18.3842 14.1335 18.0845 14.3689 17.8491L16.8087 15.4093L14.3689 12.9695C14.1335 12.7341 14.0157 12.4345 14.0157 12.0706C14.0157 11.7068 14.1335 11.4072 14.3689 11.1717C14.6043 10.9363 14.9039 10.8186 15.2678 10.8186C15.6316 10.8186 15.9312 10.9363 16.1666 11.1717L18.6064 13.6116L21.0462 11.1717C21.2817 10.9363 21.5813 10.8186 21.9451 10.8186C22.309 10.8186 22.6086 10.9363 22.844 11.1717C23.0794 11.4072 23.1971 11.7068 23.1971 12.0706C23.1971 12.4345 23.0794 12.7341 22.844 12.9695L20.4042 15.4093L22.844 17.8491C23.0794 18.0845 23.1971 18.3842 23.1971 18.748C23.1971 19.1118 23.0794 19.4114 22.844 19.6469C22.6086 19.8823 22.309 20 21.9451 20C21.5813 20 21.2817 19.8823 21.0462 19.6469L18.6064 17.2071ZM1.91302 12.8411C1.54918 12.8411 1.24421 12.718 0.998088 12.4719C0.751967 12.2258 0.628906 11.9208 0.628906 11.557C0.628906 11.1932 0.751967 10.8882 0.998088 10.6421C1.24421 10.3959 1.54918 10.2729 1.91302 10.2729H8.33356C8.69739 10.2729 9.00237 10.3959 9.24849 10.6421C9.49461 10.8882 9.61767 11.1932 9.61767 11.557C9.61767 11.9208 9.49461 12.2258 9.24849 12.4719C9.00237 12.718 8.69739 12.8411 8.33356 12.8411H1.91302ZM1.91302 7.70465C1.54918 7.70465 1.24421 7.58159 0.998088 7.33547C0.751967 7.08935 0.628906 6.78438 0.628906 6.42055C0.628906 6.05671 0.751967 5.75174 0.998088 5.50562C1.24421 5.2595 1.54918 5.13644 1.91302 5.13644H13.47C13.8338 5.13644 14.1388 5.2595 14.3849 5.50562C14.631 5.75174 14.7541 6.05671 14.7541 6.42055C14.7541 6.78438 14.631 7.08935 14.3849 7.33547C14.1388 7.58159 13.8338 7.70465 13.47 7.70465H1.91302ZM1.91302 2.56822C1.54918 2.56822 1.24421 2.44516 0.998088 2.19904C0.751967 1.95292 0.628906 1.64794 0.628906 1.28411C0.628906 0.920278 0.751967 0.615302 0.998088 0.369181C1.24421 0.12306 1.54918 0 1.91302 0H13.47C13.8338 0 14.1388 0.12306 14.3849 0.369181C14.631 0.615302 14.7541 0.920278 14.7541 1.28411C14.7541 1.64794 14.631 1.95292 14.3849 2.19904C14.1388 2.44516 13.8338 2.56822 13.47 2.56822H1.91302Z"
          fill={color}
        />
      </svg>

      <Tooltip id={`DeleteIcon${id}`} content={"Delete from Playlist"} />
    </div>
  );
};

export const AddIcon = ({ id = "ID" }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id={`AddIcon${id}`}>
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.42801 11.4286C1.1042 11.4286 0.832775 11.319 0.613728 11.1C0.39468 10.881 0.285156 10.6095 0.285156 10.2857C0.285156 9.96191 0.39468 9.69048 0.613728 9.47143C0.832775 9.25238 1.1042 9.14286 1.42801 9.14286H7.1423C7.46611 9.14286 7.73754 9.25238 7.95658 9.47143C8.17563 9.69048 8.28516 9.96191 8.28516 10.2857C8.28516 10.6095 8.17563 10.881 7.95658 11.1C7.73754 11.319 7.46611 11.4286 7.1423 11.4286H1.42801ZM1.42801 6.85714C1.1042 6.85714 0.832775 6.74762 0.613728 6.52857C0.39468 6.30952 0.285156 6.0381 0.285156 5.71429C0.285156 5.39048 0.39468 5.11905 0.613728 4.9C0.832775 4.68095 1.1042 4.57143 1.42801 4.57143H11.7137C12.0375 4.57143 12.309 4.68095 12.528 4.9C12.7471 5.11905 12.8566 5.39048 12.8566 5.71429C12.8566 6.0381 12.7471 6.30952 12.528 6.52857C12.309 6.74762 12.0375 6.85714 11.7137 6.85714H1.42801ZM1.42801 2.28571C1.1042 2.28571 0.832775 2.17619 0.613728 1.95714C0.39468 1.7381 0.285156 1.46667 0.285156 1.14286C0.285156 0.819048 0.39468 0.547619 0.613728 0.328571C0.832775 0.109524 1.1042 0 1.42801 0H11.7137C12.0375 0 12.309 0.109524 12.528 0.328571C12.7471 0.547619 12.8566 0.819048 12.8566 1.14286C12.8566 1.46667 12.7471 1.7381 12.528 1.95714C12.309 2.17619 12.0375 2.28571 11.7137 2.28571H1.42801ZM16.2852 16C15.9613 16 15.6899 15.8905 15.4709 15.6714C15.2518 15.4524 15.1423 15.181 15.1423 14.8571V11.4286H11.7137C11.3899 11.4286 11.1185 11.319 10.8994 11.1C10.6804 10.881 10.5709 10.6095 10.5709 10.2857C10.5709 9.96191 10.6804 9.69048 10.8994 9.47143C11.1185 9.25238 11.3899 9.14286 11.7137 9.14286H15.1423V5.71429C15.1423 5.39048 15.2518 5.11905 15.4709 4.9C15.6899 4.68095 15.9613 4.57143 16.2852 4.57143C16.609 4.57143 16.8804 4.68095 17.0994 4.9C17.3185 5.11905 17.428 5.39048 17.428 5.71429V9.14286H20.8566C21.1804 9.14286 21.4518 9.25238 21.6709 9.47143C21.8899 9.69048 21.9994 9.96191 21.9994 10.2857C21.9994 10.6095 21.8899 10.881 21.6709 11.1C21.4518 11.319 21.1804 11.4286 20.8566 11.4286H17.428V14.8571C17.428 15.181 17.3185 15.4524 17.0994 15.6714C16.8804 15.8905 16.609 16 16.2852 16Z"
          fill={color}
        />
      </svg>

      <Tooltip id={`AddIcon${id}`} content={"Add to PlayList"} />
    </div>
  );
};

export const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 488 512"
    fill="#ffffff"
    width="15"
    height="15"
  >
    <style></style>
    <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
  </svg>
);

export const ShuffleIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="ShuffleIconId">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="28"
        height="25"
      >
        <path
          fill={color}
          d="M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
        />
      </svg>

      <Tooltip id={"ShuffleIconId"} content={"Shuffle playList"} />
    </div>
  );
};

export const StarSolidIcon = ({ id }) => {
  return (
    <div className="relative" data-tooltip-id={`StarSolidIcon${id}`}>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8992 20L9.3188 18.5831C7.48411 16.9301 5.9673 15.5041 4.76839 14.3052C3.56948 13.1063 2.6158 12.03 1.90736 11.0763C1.19891 10.1226 0.703906 9.24614 0.422343 8.44687C0.140781 7.64759 0 6.83015 0 5.99455C0 4.28701 0.572207 2.86104 1.71662 1.71662C2.86104 0.572207 4.28701 0 5.99455 0C6.93915 0 7.83833 0.199818 8.6921 0.599455C9.54587 0.999092 10.2816 1.56222 10.8992 2.28883C11.5168 1.56222 12.2525 0.999092 13.1063 0.599455C13.96 0.199818 14.8592 0 15.8038 0C17.5114 0 18.9373 0.572207 20.0817 1.71662C21.2262 2.86104 21.7984 4.28701 21.7984 5.99455C21.7984 6.83015 21.6576 7.64759 21.376 8.44687C21.0945 9.24614 20.5995 10.1226 19.891 11.0763C19.1826 12.03 18.2289 13.1063 17.03 14.3052C15.8311 15.5041 14.3143 16.9301 12.4796 18.5831L10.8992 20Z"
          fill="#EE4723"
        />
      </svg>
      <Tooltip id={`StarSolidIcon${id}`} content={"Delete from Likes"} />
    </div>
  );
};

export const StarEmptyIcon = ({ id }) => {
  return (
    <div className="relative" data-tooltip-id={`StarEmptyIcon${id}`}>
      <svg
        width="23"
        height="20"
        viewBox="0 0 23 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.3154 20C11.0514 20 10.7826 19.9529 10.5092 19.8586C10.2357 19.7643 9.99529 19.6134 9.78784 19.4059L7.83593 17.6238C5.83687 15.7944 4.03112 13.9793 2.41867 12.1782C0.806223 10.3772 0 8.39227 0 6.22348C0 4.45073 0.594059 2.9703 1.78218 1.78218C2.9703 0.594059 4.45073 0 6.22348 0C7.22301 0 8.16596 0.212164 9.05233 0.636492C9.93871 1.06082 10.6931 1.64074 11.3154 2.37624C11.9378 1.64074 12.6921 1.06082 13.5785 0.636492C14.4649 0.212164 15.4078 0 16.4074 0C18.1801 0 19.6605 0.594059 20.8487 1.78218C22.0368 2.9703 22.6308 4.45073 22.6308 6.22348C22.6308 8.39227 21.8293 10.3819 20.2263 12.1924C18.6233 14.0028 16.8034 15.8227 14.7666 17.6521L12.843 19.4059C12.6355 19.6134 12.3951 19.7643 12.1216 19.8586C11.8482 19.9529 11.5794 20 11.3154 20ZM10.2405 4.63932C9.69354 3.8661 9.10891 3.27676 8.48656 2.87129C7.86421 2.46582 7.10985 2.26308 6.22348 2.26308C5.09194 2.26308 4.14899 2.64026 3.39462 3.39463C2.64026 4.14899 2.26308 5.09194 2.26308 6.22348C2.26308 7.20415 2.61198 8.24611 3.30976 9.34936C4.00754 10.4526 4.84206 11.5229 5.8133 12.5601C6.78453 13.5974 7.78406 14.5686 8.81188 15.4738C9.8397 16.3791 10.6742 17.124 11.3154 17.7086C11.9566 17.124 12.7911 16.3791 13.819 15.4738C14.8468 14.5686 15.8463 13.5974 16.8175 12.5601C17.7888 11.5229 18.6233 10.4526 19.3211 9.34936C20.0189 8.24611 20.3677 7.20415 20.3677 6.22348C20.3677 5.09194 19.9906 4.14899 19.2362 3.39463C18.4818 2.64026 17.5389 2.26308 16.4074 2.26308C15.521 2.26308 14.7666 2.46582 14.1443 2.87129C13.5219 3.27676 12.9373 3.8661 12.3904 4.63932C12.2584 4.82791 12.0981 4.96935 11.9095 5.06365C11.7209 5.15794 11.5229 5.20509 11.3154 5.20509C11.108 5.20509 10.9099 5.15794 10.7214 5.06365C10.5328 4.96935 10.3725 4.82791 10.2405 4.63932Z"
          fill="#EE4723"
        />
      </svg>
      <Tooltip id={`StarEmptyIcon${id}`} content={"Add to Likes"} />
    </div>
  );
};

export const DragAndDropIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        width="23"
        viewBox="0 0 320 512"
      >
        <path
          fill={color}
          d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
        />
      </svg>
    </div>
  );
};

export const CurrentyPlaying = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative">
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8608 5.45981C15.7749 4.31699 15.4283 3.24004 14.8268 2.26048C14.5375 1.79075 14.1938 1.35252 13.8014 0.962989C13.6353 0.796864 13.4262 0.710938 13.2114 0.710938C13.0854 0.710938 12.9565 0.73958 12.8333 0.802592C12.5211 0.95726 12.3464 1.29237 12.3865 1.65327C12.4123 1.87954 12.544 2.03993 12.7015 2.21465C14.1766 3.84439 14.5833 5.73478 13.9074 7.83139C13.6725 8.55603 13.2515 9.22912 12.6156 9.89076C12.2948 10.223 12.3006 10.7357 12.6299 11.0536C12.9593 11.3744 13.472 11.3716 13.7957 11.0479C14.844 9.99674 15.5085 8.71929 15.7691 7.25568C15.8035 7.06664 15.8264 6.86901 15.8493 6.67997C15.8608 6.59118 15.8694 6.50525 15.8808 6.41646L15.8751 5.55433C15.8694 5.52283 15.8636 5.49132 15.8608 5.45981Z"
          fill={`${color}`}
        />
        <path
          d="M3.1621 9.77389L3.12773 9.73379C1.98204 8.47067 1.50371 6.97841 1.70994 5.29425C1.85601 4.08269 2.38303 3.01433 3.27094 2.1207C3.45998 1.93166 3.53731 1.70539 3.50294 1.44761C3.45711 1.10103 3.26235 0.863304 2.93582 0.754464C2.61217 0.648488 2.32575 0.720093 2.07942 0.969281C0.736104 2.33551 0.0372348 3.9853 0 5.87569C0.0114569 7.28775 0.335113 8.51363 0.985291 9.62782C1.29176 10.152 1.66125 10.6274 2.08229 11.0456C2.34579 11.3062 2.72674 11.3664 3.05039 11.2003C3.37119 11.0341 3.54304 10.6904 3.48862 10.321C3.45998 10.0975 3.31677 9.94002 3.1621 9.77389Z"
          fill={`${color}`}
        />
        <path
          d="M12.1976 5.25425C12.0458 4.41217 11.6591 3.67893 11.0519 3.07744C10.8915 2.91705 10.6882 2.83398 10.4733 2.83398C10.4504 2.83398 10.4275 2.83398 10.4017 2.83685C10.1611 2.8569 9.9406 2.98579 9.79738 3.18628C9.55393 3.52999 9.59402 3.94817 9.90622 4.27469C10.333 4.72151 10.565 5.24852 10.5994 5.84141C10.6423 6.56606 10.4017 7.21051 9.88045 7.76044C9.71719 7.93229 9.63126 8.15284 9.63699 8.37338C9.64272 8.5882 9.73723 8.79156 9.9005 8.9405C10.2499 9.26416 10.7483 9.24411 11.0863 8.89181C11.8768 8.06978 12.252 7.11313 12.2663 5.88438C12.2635 5.84714 12.2577 5.80418 12.2549 5.75262C12.2434 5.61514 12.2291 5.42897 12.1976 5.25425Z"
          fill={`${color}`}
        />
        <path
          d="M5.70074 3.06366C5.35417 2.73714 4.85293 2.75719 4.50636 3.11522C3.73302 3.92006 3.34922 4.88244 3.33203 6.05391C3.3349 6.08828 3.33776 6.12838 3.34062 6.1742C3.34635 6.28591 3.35494 6.41193 3.37213 6.5351C3.49816 7.48315 3.90201 8.29086 4.56651 8.93818C4.76987 9.13581 5.05629 9.21028 5.33126 9.14153C5.61195 9.06993 5.83249 8.86371 5.91842 8.58874C6.01867 8.26795 5.94133 7.98153 5.68069 7.70942C5.26824 7.28266 5.04197 6.7671 5.00187 6.17993C4.95318 5.44669 5.19091 4.79938 5.70647 4.25804C5.87546 4.08046 5.96711 3.85705 5.96138 3.63078C5.95566 3.41882 5.864 3.21833 5.70074 3.06366Z"
          fill={`${color}`}
        />
        <path
          d="M7.80612 4.87109C7.80325 4.87109 7.80039 4.87109 7.79753 4.87109C7.17599 4.87396 6.66902 5.38379 6.67189 6.00246C6.67189 6.624 7.17885 7.13096 7.80039 7.13383C7.80039 7.13383 7.80325 7.13383 7.80612 7.13383C8.42479 7.13383 8.92889 6.62972 8.93462 6.00819C8.93748 5.71031 8.82005 5.42389 8.60237 5.20621C8.38183 4.98853 8.10113 4.87109 7.80612 4.87109Z"
          fill={`${color}`}
        />
        <path
          d="M7.79619 4.72673C7.09446 4.73246 6.52734 5.30244 6.52734 6.00131C6.52734 6.70018 7.09732 7.27303 7.79906 7.27589C7.80192 7.27589 7.80192 7.27589 7.80479 7.27589C8.50079 7.27589 9.07077 6.70877 9.0765 6.00704C9.07936 5.66906 8.94474 5.34827 8.70129 5.10481C8.45496 4.85849 8.13703 4.72101 7.79619 4.72673ZM7.79619 7.20142C7.14029 7.19856 6.59608 6.65436 6.59608 5.99845C6.59608 5.34254 7.13742 4.79834 7.79333 4.79548C8.4521 4.78975 9.00489 5.34541 8.99916 6.00418C8.9963 6.66295 8.4521 7.20428 7.79619 7.20142Z"
          fill="#EE4723"
        />
        <path
          d="M7.79491 4.79887C7.13901 4.8046 6.5948 5.3488 6.59767 6.00184C6.59767 6.65775 7.14187 7.20195 7.79777 7.20482C8.45082 7.20768 8.99788 6.66634 9.00361 6.00757C9.00648 5.3488 8.45368 4.79314 7.79491 4.79887ZM7.80064 7.13035C7.80064 7.13035 7.79778 7.13035 7.79491 7.13035C7.17338 7.12748 6.66641 6.62052 6.66641 5.99898C6.66641 5.37744 7.17051 4.87048 7.79205 4.86761C7.79491 4.86761 7.79777 4.86761 7.80064 4.86761C8.09852 4.86761 8.37921 4.98791 8.59403 5.20273C8.81171 5.42041 8.92914 5.70397 8.92628 6.00471C8.92341 6.62624 8.41931 7.13035 7.80064 7.13035Z"
          fill="#EE4723"
        />
      </svg>
    </div>
  );
};

export const SearchIcon = ({ hover }) => {
  const { mode } = useContext(ThemeContext);

  let color = mode === "dark" ? "#fff" : "#000";

  if (hover) {
    color = "#098898";
  }

  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.52114 16C1.23735 16 0.99947 15.904 0.807494 15.7119C0.615519 15.5199 0.519531 15.2819 0.519531 14.998C0.519531 14.7141 0.615519 14.4762 0.807494 14.2845C0.99947 14.0927 1.23735 13.9968 1.52114 13.9968H12.5774C12.8612 13.9968 13.0991 14.0929 13.291 14.2849C13.483 14.477 13.579 14.715 13.579 14.9989C13.579 15.2828 13.483 15.5206 13.291 15.7124C13.0991 15.9041 12.8612 16 12.5774 16H1.52114ZM1.52114 9.46385C1.23735 9.46385 0.99947 9.36783 0.807494 9.17579C0.615519 8.98373 0.519531 8.74574 0.519531 8.46184C0.519531 8.17792 0.615519 7.94008 0.807494 7.74833C0.99947 7.55658 1.23735 7.4607 1.52114 7.4607H5.83578C6.11957 7.4607 6.35745 7.55672 6.54943 7.74876C6.74138 7.94083 6.83736 8.17882 6.83736 8.46274C6.83736 8.74665 6.74138 8.98447 6.54943 9.17623C6.35745 9.36798 6.11957 9.46385 5.83578 9.46385H1.52114ZM1.52114 2.92771C1.23735 2.92771 0.99947 2.83169 0.807494 2.63965C0.615519 2.44758 0.519531 2.2096 0.519531 1.9257C0.519531 1.64178 0.615519 1.40394 0.807494 1.21218C0.99947 1.02043 1.23735 0.924554 1.52114 0.924554H5.83578C6.11957 0.924554 6.35745 1.02059 6.54943 1.21265C6.74138 1.40469 6.83736 1.64268 6.83736 1.9266C6.83736 2.2105 6.74138 2.44833 6.54943 2.64008C6.35745 2.83183 6.11957 2.92771 5.83578 2.92771H1.52114ZM15.8261 12.0321C14.1528 12.0321 12.7265 11.4474 11.5471 10.278C10.3677 9.10861 9.77802 7.68795 9.77802 6.01604C9.77802 4.34415 10.368 2.9235 11.548 1.75409C12.728 0.584697 14.155 0 15.8292 0C17.5034 0 18.9294 0.584697 20.1074 1.75409C21.2853 2.9235 21.8743 4.34202 21.8743 6.00963C21.8743 6.62943 21.7776 7.23938 21.5841 7.83948C21.3906 8.4396 21.1047 8.98963 20.7263 9.48956L25.1899 13.9146C25.3834 14.0967 25.4801 14.3284 25.4801 14.6098C25.4801 14.8911 25.3834 15.1285 25.1899 15.322C25.0079 15.5069 24.7762 15.5994 24.4948 15.5994C24.2134 15.5994 23.976 15.5069 23.7825 15.322L19.3189 10.8969C18.8104 11.2668 18.2561 11.5484 17.656 11.7419C17.0559 11.9354 16.4459 12.0321 15.8261 12.0321ZM15.8261 10.0289C16.9498 10.0289 17.9048 9.63942 18.6914 8.86038C19.4779 8.08135 19.8711 7.13324 19.8711 6.01604C19.8711 4.89887 19.4779 3.95077 18.6914 3.17174C17.9048 2.3927 16.9498 2.00319 15.8261 2.00319C14.7026 2.00319 13.7475 2.3927 12.961 3.17174C12.1744 3.95077 11.7812 4.89887 11.7812 6.01604C11.7812 7.13324 12.1744 8.08135 12.961 8.86038C13.7475 9.63942 14.7026 10.0289 15.8261 10.0289Z"
        fill={color}
      />
    </svg>
  );
};

export const LikesIcon = ({ hover }) => {
  const { mode } = useContext(ThemeContext);

  let color = mode === "dark" ? "#fff" : "#000";

  if (hover) {
    color = "#098898";
  }

  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0016 16C9.79033 16 9.57534 15.9623 9.35657 15.8868C9.13781 15.8114 8.94545 15.6907 8.77949 15.5248L7.21796 14.099C5.61871 12.6355 4.17411 11.1834 2.88415 9.74257C1.5942 8.30174 0.949219 6.71381 0.949219 4.97878C0.949219 3.56058 1.42447 2.37624 2.37496 1.42574C3.32546 0.475248 4.5098 0 5.928 0C6.72762 0 7.48199 0.169731 8.19108 0.509194C8.90018 0.848656 9.50367 1.31259 10.0016 1.90099C10.4994 1.31259 11.1029 0.848656 11.812 0.509194C12.5211 0.169731 13.2755 0 14.0751 0C15.4933 0 16.6776 0.475248 17.6281 1.42574C18.5786 2.37624 19.0539 3.56058 19.0539 4.97878C19.0539 6.71381 18.4127 8.30552 17.1303 9.75389C15.8478 11.2023 14.3919 12.6582 12.7625 14.1216L11.2236 15.5248C11.0577 15.6907 10.8653 15.8114 10.6465 15.8868C10.4278 15.9623 10.2128 16 10.0016 16ZM9.14158 3.71146C8.70405 3.09288 8.23635 2.6214 7.73847 2.29703C7.24059 1.97265 6.6371 1.81047 5.928 1.81047C5.02277 1.81047 4.26841 2.11221 3.66492 2.7157C3.06143 3.31919 2.75969 4.07355 2.75969 4.97878C2.75969 5.76332 3.0388 6.59689 3.59703 7.47949C4.15525 8.36209 4.82286 9.21829 5.59985 10.0481C6.37685 10.8779 7.17647 11.6549 7.99872 12.3791C8.82098 13.1033 9.48859 13.6992 10.0016 14.1669C10.5145 13.6992 11.1821 13.1033 12.0044 12.3791C12.8266 11.6549 13.6263 10.8779 14.4032 10.0481C15.1802 9.21829 15.8478 8.36209 16.4061 7.47949C16.9643 6.59689 17.2434 5.76332 17.2434 4.97878C17.2434 4.07355 16.9417 3.31919 16.3382 2.7157C15.7347 2.11221 14.9803 1.81047 14.0751 1.81047C13.366 1.81047 12.7625 1.97265 12.2646 2.29703C11.7668 2.6214 11.2991 3.09288 10.8615 3.71146C10.7559 3.86233 10.6277 3.97548 10.4768 4.05092C10.3259 4.12636 10.1675 4.16407 10.0016 4.16407C9.83559 4.16407 9.67718 4.12636 9.5263 4.05092C9.37543 3.97548 9.24719 3.86233 9.14158 3.71146Z"
        fill={color}
      />
    </svg>
  );
};

export const ReadMeIcon = ({ hover }) => {
  const { mode } = useContext(ThemeContext);

  let color = mode === "dark" ? "#fff" : "#000";

  if (hover) {
    color = "#098898";
  }

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.52942 12.4706H9.64704V11.0589H3.52942V12.4706ZM3.52942 8.70586H12.4706V7.29414H3.52942V8.70586ZM3.52942 4.94114H12.4706V3.52942H3.52942V4.94114ZM1.70137 16C1.22595 16 0.823532 15.8353 0.494119 15.5059C0.164706 15.1765 0 14.7741 0 14.2986V1.70137C0 1.22595 0.164706 0.823532 0.494119 0.494119C0.823532 0.164706 1.22595 0 1.70137 0H14.2986C14.774 0 15.1765 0.164706 15.5059 0.494119C15.8353 0.823532 16 1.22595 16 1.70137V14.2986C16 14.7741 15.8353 15.1765 15.5059 15.5059C15.1765 15.8353 14.774 16 14.2986 16H1.70137ZM1.70137 14.5883H14.2986C14.371 14.5883 14.4374 14.5581 14.4978 14.4978C14.5581 14.4374 14.5883 14.371 14.5883 14.2986V1.70137C14.5883 1.62896 14.5581 1.56259 14.4978 1.50224C14.4374 1.44191 14.371 1.41175 14.2986 1.41175H1.70137C1.62896 1.41175 1.56258 1.44191 1.50224 1.50224C1.44191 1.56259 1.41175 1.62896 1.41175 1.70137V14.2986C1.41175 14.371 1.44191 14.4374 1.50224 14.4978C1.56258 14.5581 1.62896 14.5883 1.70137 14.5883Z"
        fill={color}
      />
    </svg>
  );
};

export const UsersIcon = ({ hover, width = "24", height = "16" }) => {
  const { mode } = useContext(ThemeContext);

  let color = mode === "dark" ? "#fff" : "#000";

  if (hover) {
    color = "#098898";
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.832031 15.0105V13.5663C0.832031 13.0021 0.97765 12.4986 1.26889 12.0558C1.56011 11.613 1.94903 11.2685 2.43567 11.0223C3.47605 10.5134 4.52221 10.1211 5.57413 9.8453C6.62607 9.56951 7.78222 9.43162 9.04258 9.43162C10.3029 9.43162 11.4591 9.56951 12.511 9.8453C13.5629 10.1211 14.6091 10.5134 15.6495 11.0223C16.1361 11.2685 16.525 11.613 16.8163 12.0558C17.1075 12.4986 17.2531 13.0021 17.2531 13.5663V15.0105C17.2531 15.2909 17.1583 15.5259 16.9686 15.7155C16.779 15.9052 16.544 16 16.2636 16H1.82151C1.54117 16 1.30616 15.9052 1.1165 15.7155C0.926854 15.5259 0.832031 15.2909 0.832031 15.0105ZM19.0173 16C19.1516 15.8855 19.2561 15.7423 19.3307 15.5705C19.4053 15.3987 19.4426 15.2064 19.4426 14.9937V13.4316C19.4426 12.713 19.2666 12.0282 18.9147 11.3771C18.5628 10.726 18.0637 10.1673 17.4174 9.70109C18.1514 9.81057 18.8482 9.98004 19.5079 10.2095C20.1675 10.439 20.797 10.7102 21.3963 11.0232C21.9619 11.3249 22.3987 11.6806 22.7068 12.0901C23.0149 12.4997 23.1689 12.9468 23.1689 13.4316V15.0105C23.1689 15.2909 23.0741 15.5259 22.8844 15.7155C22.6948 15.9052 22.4598 16 22.1794 16H19.0173ZM9.04258 7.66312C7.98891 7.66312 7.08689 7.28795 6.33654 6.53761C5.58618 5.78726 5.211 4.88525 5.211 3.83157C5.211 2.77788 5.58618 1.87587 6.33654 1.12553C7.08689 0.375178 7.98891 0 9.04258 0C10.0962 0 10.9983 0.375178 11.7486 1.12553C12.499 1.87587 12.8741 2.77788 12.8741 3.83157C12.8741 4.88525 12.499 5.78726 11.7486 6.53761C10.9983 7.28795 10.0962 7.66312 9.04258 7.66312ZM18.4952 3.83157C18.4952 4.88525 18.12 5.78726 17.3696 6.53761C16.6193 7.28795 15.7173 7.66312 14.6636 7.66312C14.5401 7.66312 14.3829 7.64909 14.192 7.62103C14.0012 7.59297 13.844 7.56209 13.7205 7.52841C14.1522 7.00938 14.484 6.43357 14.7158 5.80099C14.9477 5.16841 15.0636 4.5115 15.0636 3.83026C15.0636 3.14904 14.9454 2.49474 14.7089 1.86736C14.4724 1.24 14.1429 0.662457 13.7205 0.134736C13.8777 0.0785944 14.0348 0.0421029 14.192 0.0252621C14.3492 0.00842135 14.5064 0 14.6636 0C15.7173 0 16.6193 0.375178 17.3696 1.12553C18.12 1.87587 18.4952 2.77788 18.4952 3.83157ZM2.47412 14.3579H15.611V13.5663C15.611 13.3376 15.5538 13.1341 15.4395 12.9558C15.3251 12.7775 15.1437 12.6218 14.8952 12.4884C13.9942 12.0239 13.0665 11.6719 12.1121 11.4326C11.1577 11.1933 10.1345 11.0737 9.04258 11.0737C7.95064 11.0737 6.92748 11.1933 5.97308 11.4326C5.0187 11.6719 4.09098 12.0239 3.18992 12.4884C2.9415 12.6218 2.76009 12.7775 2.64569 12.9558C2.53131 13.1341 2.47412 13.3376 2.47412 13.5663V14.3579ZM9.04258 6.02106C9.64469 6.02106 10.1601 5.80667 10.5889 5.3779C11.0177 4.94912 11.2321 4.43368 11.2321 3.83157C11.2321 3.22947 11.0177 2.71402 10.5889 2.28525C10.1601 1.85647 9.64469 1.64209 9.04258 1.64209C8.44047 1.64209 7.92503 1.85647 7.49625 2.28525C7.06748 2.71402 6.85309 3.22947 6.85309 3.83157C6.85309 4.43368 7.06748 4.94912 7.49625 5.3779C7.92503 5.80667 8.44047 6.02106 9.04258 6.02106Z"
        fill={color}
      />
    </svg>
  );
};

export const SyncDBIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <div className="relative" data-tooltip-id="SyncDBIconId">
      <svg
        version="1.1"
        id="Uploaded to svgrepo.com"
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 32 32"
      >
        <path
          fill={color}
          d="M30,16c0,3.279-2.631,5.939-5.896,5.995l-0.629-0.001C23.22,25.905,19.975,29,16,29
	c-2.464,0-4.634-1.201-6-3.036V27.5c0,0.276-0.224,0.5-0.5,0.5S9,27.776,9,27.5V24h3.5c0.276,0,0.5,0.224,0.5,0.5S12.776,25,12.5,25
	h-1.955c1.157,1.798,3.162,3,5.455,3c3.418,0,6.222-2.653,6.475-6.008L9.528,21.974C9.515,21.817,9.5,21.66,9.5,21.5
	c0-3.584,2.916-6.5,6.5-6.5c2.292,0,4.298,1.202,5.454,3H19.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5H23v-3.5
	c0-0.276-0.224-0.5-0.5-0.5S22,15.224,22,15.5v1.528C20.634,15.195,18.462,14,16,14c-4.142,0-7.5,3.358-7.5,7.5
	c0,0.16,0.01,0.316,0.022,0.473l-0.061,0C4.848,21.697,2,18.684,2,15c0-3.613,2.738-6.585,6.252-6.959C9.127,4.572,12.259,2,16,2
	c4.418,0,8,3.582,8,8C27.314,10,30,12.686,30,16z"
        />
      </svg>

      <Tooltip id={"SyncDBIconId"} content={"Sync Playlist"} />
    </div>
  );
};

export const AdminRoleIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative" data-tooltip-id="AdminRoleIcon">
      <svg
        fill={color}
        height="17px"
        width="17px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
      >
        <g id="user-admin">
          <path
            d="M22.3,16.7l1.4-1.4L20,11.6l-5.8,5.8c-0.5-0.3-1.1-0.4-1.7-0.4C10.6,17,9,18.6,9,20.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5
		c0-0.6-0.2-1.2-0.4-1.7l1.9-1.9l2.3,2.3l1.4-1.4l-2.3-2.3l1.1-1.1L22.3,16.7z M12.5,22c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5
		s1.5,0.7,1.5,1.5S13.3,22,12.5,22z"
          />
          <path
            d="M2,19c0-3.9,3.1-7,7-7c2,0,3.9,0.9,5.3,2.4l1.5-1.3c-0.9-1-1.9-1.8-3.1-2.3C14.1,9.7,15,7.9,15,6c0-3.3-2.7-6-6-6
		S3,2.7,3,6c0,1.9,0.9,3.7,2.4,4.8C2.2,12.2,0,15.3,0,19v5h8v-2H2V19z M5,6c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S5,8.2,5,6z"
          />
        </g>
      </svg>

      <Tooltip id={"AdminRoleIcon"} content={"Admin role"} />
    </span>
  );
};

export const UserRoleIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative" data-tooltip-id="UserRoleIcon">
      <svg
        fill={color}
        height="17px"
        width="17px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
      >
        <g id="user-expert">
          <path
            d="M2,19c0-3.9,3.1-7,7-7c2.5,0,4.8,1.3,6.1,3.5l1.7-1c-1-1.7-2.5-3-4.2-3.7C14.1,9.7,15,7.9,15,6c0-3.3-2.7-6-6-6S3,2.7,3,6
		c0,1.9,0.9,3.7,2.4,4.8C2.2,12.2,0,15.3,0,19v5h12v-2H2V19z M5,6c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S5,8.2,5,6z"
          />
          <path d="M24.1,15.8l-7.6,7.6l-4.7-4.7l1.4-1.4l3.3,3.3l6.2-6.2L24.1,15.8z" />
        </g>
      </svg>

      <Tooltip id={"UserRoleIcon"} content={"User role"} />
    </span>
  );
};

export const AnonymousRoleIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative left-[-2px]" data-tooltip-id="Anonymous">
      <svg
        fill={color}
        width="20px"
        height="20px"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Hacker_anonymous">
          <path d="M475.3571,413.24a69.9,69.9,0,0,0-39.8845-57.4407l-39.9287-18.7987,21.5791-44.5621a89.4527,89.4527,0,0,0,.0025-77.9684L359.7988,96.0682C317.7933,9.3105,194.2088,9.31,152.2019,96.0666L94.87,214.4745a89.445,89.445,0,0,0,.0049,77.9692l21.581,44.5569L76.5256,355.8a69.898,69.898,0,0,0-39.8831,57.439l-3.612,43.3773a22.5157,22.5157,0,0,0,22.4381,24.3842H456.5337A22.5134,22.5134,0,0,0,478.97,456.6187ZM364,260.1205a107.9746,107.9746,0,0,1-98.1035,107.5V341.1249a9.8965,9.8965,0,0,0-19.793,0v26.4957A107.9746,107.9746,0,0,1,148,260.1205V203.44a28.8192,28.8192,0,0,1,28.8193-28.8193H335.1806A28.8193,28.8193,0,0,1,364,203.44Z" />

          <path d="M321.8213,275.9979a9.91,9.91,0,0,0-12.3135,6.6709,13.5776,13.5776,0,0,1-26.0156,0,9.9026,9.9026,0,1,0-18.9844,5.6426,33.3877,33.3877,0,0,0,63.9844,0A9.9125,9.9125,0,0,0,321.8213,275.9979Z" />

          <path d="M240.8213,275.9979a9.8908,9.8908,0,0,0-12.3135,6.6709,13.5776,13.5776,0,0,1-26.0156,0,9.9026,9.9026,0,1,0-18.9844,5.6426,33.3877,33.3877,0,0,0,63.9844,0A9.9125,9.9125,0,0,0,240.8213,275.9979Z" />

          <path d="M319,227.4384H283a9.8965,9.8965,0,1,0,0,19.7929h36a9.8965,9.8965,0,1,0,0-19.7929Z" />

          <path d="M193,247.2313h36a9.8965,9.8965,0,1,0,0-19.7929H193a9.8965,9.8965,0,1,0,0,19.7929Z" />
        </g>
      </svg>

      <Tooltip id={"Anonymous"} content={"Anonymous role"} />
    </span>
  );
};

export const LikeIcon = ({ isLiked }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";
  isLiked = isLiked ? "#EE4723" : color;

  return (
    <span className="relative">
      <svg
        width="21px"
        height="21px"
        viewBox="0 0 24 24"
        fill={isLiked}
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: "pointer" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0501 7.04419C15.4673 5.79254 14.5357 4.5 13.2163 4.5C12.5921 4.5 12.0062 4.80147 11.6434 5.30944L8.47155 9.75H5.85748L5.10748 10.5V18L5.85748 18.75H16.8211L19.1247 14.1428C19.8088 12.7747 19.5406 11.1224 18.4591 10.0408C17.7926 9.37439 16.8888 9 15.9463 9H14.3981L15.0501 7.04419ZM9.60751 10.7404L12.864 6.1813C12.9453 6.06753 13.0765 6 13.2163 6C13.5118 6 13.7205 6.28951 13.627 6.56984L12.317 10.5H15.9463C16.491 10.5 17.0133 10.7164 17.3984 11.1015C18.0235 11.7265 18.1784 12.6814 17.7831 13.472L15.8941 17.25H9.60751V10.7404ZM8.10751 17.25H6.60748V11.25H8.10751V17.25Z"
          fill={isLiked}
        />
      </svg>
    </span>
  );
};

export const DislikeIcon = ({ isDisliked }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";
  isDisliked = isDisliked ? "#EE4723" : color;

  return (
    <span className="relative">
      <svg
        width="21px"
        height="21px"
        viewBox="0 0 24 24"
        fill={isDisliked}
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: "pointer" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0501 16.9558C15.4673 18.2075 14.5357 19.5 13.2164 19.5C12.5921 19.5 12.0063 19.1985 11.6435 18.6906L8.47164 14.25L5.85761 14.25L5.10761 13.5L5.10761 6L5.85761 5.25L16.8211 5.25L19.1247 9.85722C19.8088 11.2253 19.5407 12.8776 18.4591 13.9592C17.7927 14.6256 16.8888 15 15.9463 15L14.3982 15L15.0501 16.9558ZM9.60761 13.2596L12.8641 17.8187C12.9453 17.9325 13.0765 18 13.2164 18C13.5119 18 13.7205 17.7105 13.6271 17.4302L12.317 13.5L15.9463 13.5C16.491 13.5 17.0133 13.2836 17.3984 12.8985C18.0235 12.2735 18.1784 11.3186 17.7831 10.528L15.8941 6.75L9.60761 6.75L9.60761 13.2596ZM8.10761 6.75L6.60761 6.75L6.60761 12.75L8.10761 12.75L8.10761 6.75Z"
          fill={isDisliked}
        />
      </svg>
    </span>
  );
};

export const LnkExternalIcon = ({ ytVideoId, tooltipId }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <a
      href={`https://www.youtube.com/watch?v=${ytVideoId}`}
      target="_blank"
      rel="noreferrer"
      className="inline-block relative"
    >
      <svg
        data-tooltip-id={`ExternalIcon${ytVideoId}${tooltipId}`}
        width="22px"
        height="20px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        fill={"none"}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <polyline points="8.25 2.75,2.75 2.75,2.75 13.25,13.25 13.25,13.25 7.75" />
        <path d="m13.25 2.75-5.5 5.5m3-6.5h3.5v3.5" />
      </svg>

      <Tooltip
        id={`ExternalIcon${ytVideoId}${tooltipId}`}
        content={"Open in New Tab"}
      />
    </a>
  );
};

export const MessageEditIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative top-[-4px]" data-tooltip-id="MessageEditIcon">
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 9H17M7 13H12M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <Tooltip id={"MessageEditIcon"} content={"Edit Message"} />
    </span>
  );
};

export const ChevronUpIcon = () => {
  const { mode } = useContext(ThemeContext);
  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 14.5L12 9.5L17 14.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDownIcon = () => {
  const { mode } = useContext(ThemeContext);
  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 9.5L12 14.5L7 9.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowUpIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";
  const bgColor = mode === "dark" ? "#032633" : "#fff";

  return (
    <div style={{ backgroundColor: bgColor }} className="rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="30px"
        version="1.1"
        viewBox="0 0 256 256"
        width="30px"
        fill={color}
      >
        <path d="M128,203.313c-3.534,0-6-2.865-6-6.4V74.878l-45.956,47.141c-2.463,2.538-6.616,2.597-9.149,0.138  c-1.295-1.256-1.995-2.925-1.995-4.594c0-1.606,0.576-3.216,1.782-4.456l56.737-58.466c1.206-1.244,2.855-1.943,4.587-1.943  s3.385,0.699,4.591,1.943l56.743,58.466c2.459,2.528,2.401,6.584-0.139,9.05c-2.534,2.459-6.789,2.4-9.251-0.138L134,74.878v122.034  C134,200.447,131.534,203.313,128,203.313z M128,256c70.578,0,128-57.422,128-128S198.578,0,128,0S0,57.422,0,128  S57.422,256,128,256z M128,243.2c-63.521,0-115.2-51.679-115.2-115.2S64.479,12.8,128,12.8S243.2,64.479,243.2,128  S191.521,243.2,128,243.2z" />
      </svg>
    </div>
  );
};

export const CloseIcon = ({ className = "", forcedColor = "" }) => {
  const { mode } = useContext(ThemeContext);

  let color = mode === "dark" ? "#fff" : "#000";

  if (forcedColor) {
    color = forcedColor;
  }

  return (
    <span className={className}>
      <svg
        width="12px"
        height="12px"
        viewBox="0 -0.5 21 21"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>close [#1511]</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-419.000000, -240.000000)"
            fill={color}
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <polygon
                id="close-[#1511]"
                points="375.0183 90 384 98.554 382.48065 100 373.5 91.446 364.5183 100 363 98.554 371.98065 90 363 81.446 364.5183 80 373.5 88.554 382.48065 80 384 81.446"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
};

export const GoldAwardIcon = () => {
  const { mode } = useContext(ThemeContext);

  if (mode === "dark") {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_7987)">
          <path
            d="M197.083 148.168L176.833 127.918C172.667 139.418 163 148.501 151.167 151.918C145 153.668 138.667 154.001 132.583 152.835C130.083 156.501 127.083 159.668 123.5 162.335L153.25 192.085C155.917 194.835 160.083 195.751 163.75 194.501C165.167 194.001 166.5 193.168 167.583 192.085C169.167 190.501 170.25 188.335 170.5 185.918L172.5 167.501L191 165.418C196.583 164.835 200.583 159.835 200 154.251C199.75 152.001 198.75 149.835 197.083 148.168Z"
            fill="#354C40"
          />
          <path
            d="M67.5005 152.751C61.4172 153.917 55.0005 153.667 48.9172 151.834C37.0838 148.417 27.4172 139.334 23.2505 127.834L3.00049 148.084C1.41716 149.667 0.333824 151.834 0.0838239 154.167C-0.499509 159.751 3.50049 164.751 9.08382 165.334L27.5838 167.417L29.6672 185.834C29.9172 188.167 30.9172 190.334 32.5838 192.001C33.6672 193.084 34.9172 193.917 36.4172 194.417C40.0838 195.751 44.2505 194.751 46.9172 192.001L76.6672 162.251C73.0838 159.584 70.0838 156.417 67.5838 152.751H67.5005Z"
            fill="#354C40"
          />
          <path
            d="M176.418 63.5052C174.418 59.9219 171.751 57.1719 168.751 55.2552C163.418 51.7552 160.501 45.4219 161.918 39.1719C162.751 35.5885 162.668 31.6719 161.501 27.6719C159.418 20.5052 153.585 14.6719 146.501 12.5885C142.501 11.4219 138.585 11.4219 135.001 12.1719C128.751 13.5885 122.418 10.7552 118.918 5.33854C117.001 2.33854 114.251 -0.328125 110.668 -2.32813C104.168 -5.91146 95.918 -5.91146 89.418 -2.32813C85.8346 -0.328125 83.0846 2.33854 81.168 5.33854C77.668 10.6719 71.3346 13.5885 65.0846 12.1719C61.5013 11.3385 57.5846 11.4219 53.5846 12.5885C46.418 14.6719 40.5846 20.5052 38.5846 27.6719C37.418 31.6719 37.3346 35.5885 38.168 39.1719C39.5846 45.4219 36.7513 51.7552 31.3346 55.2552C28.3346 57.1719 25.668 59.9219 23.668 63.5052C21.8346 66.7552 20.918 70.5052 21.0013 74.2552C21.0013 78.0052 21.8346 81.6719 23.668 85.0052C25.668 88.5885 28.3346 91.3385 31.3346 93.2552C36.668 96.7552 39.5846 103.089 38.168 109.339C37.3346 112.922 37.418 116.839 38.5846 120.839C40.668 128.005 46.5013 133.839 53.5846 135.922C57.5846 137.089 61.5013 137.089 65.0846 136.339C71.3346 134.922 77.668 137.755 81.168 143.172C83.0846 146.172 85.8346 148.839 89.418 150.839C95.918 154.422 104.168 154.422 110.668 150.839C114.251 148.839 117.001 146.172 118.918 143.172C122.418 137.839 128.751 134.922 135.001 136.339C138.585 137.172 142.501 137.089 146.501 135.922C153.668 133.839 159.501 128.005 161.501 120.839C162.668 116.839 162.751 112.922 161.918 109.339C160.501 103.089 163.335 96.7552 168.751 93.2552C171.751 91.3385 174.418 88.5885 176.418 85.0052C178.251 81.7552 179.168 78.0052 179.085 74.2552C179.085 70.5052 178.168 66.8385 176.418 63.5052ZM125.085 108.922H76.5846V94.0052H92.0846V58.5885L80.2513 65.3385L73.5846 52.0052L97.5846 38.4219H110.585V94.0052H125.085V108.922Z"
            fill="#354C40"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_7987">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width="188"
        height="190"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_4712)">
          <path
            d="M197.083 148.168L176.833 127.918C172.667 139.418 163 148.501 151.167 151.918C145 153.668 138.667 154.001 132.583 152.835C130.083 156.501 127.083 159.668 123.5 162.335L153.25 192.085C155.917 194.835 160.083 195.751 163.75 194.501C165.167 194.001 166.5 193.168 167.583 192.085C169.167 190.501 170.25 188.335 170.5 185.918L172.5 167.501L191 165.418C196.583 164.835 200.583 159.835 200 154.251C199.75 152.001 198.75 149.835 197.083 148.168Z"
            fill="#F1E8BB"
          />
          <path
            d="M67.5005 152.751C61.4172 153.917 55.0005 153.667 48.9172 151.834C37.0838 148.417 27.4172 139.334 23.2505 127.834L3.00049 148.084C1.41716 149.667 0.333824 151.834 0.0838239 154.167C-0.499509 159.751 3.50049 164.751 9.08382 165.334L27.5838 167.417L29.6672 185.834C29.9172 188.167 30.9172 190.334 32.5838 192.001C33.6672 193.084 34.9172 193.917 36.4172 194.417C40.0838 195.751 44.2505 194.751 46.9172 192.001L76.6672 162.251C73.0838 159.584 70.0838 156.417 67.5838 152.751H67.5005Z"
            fill="#F1E8BB"
          />
          <path
            d="M176.418 63.5052C174.418 59.9219 171.751 57.1719 168.751 55.2552C163.418 51.7552 160.501 45.4219 161.918 39.1719C162.751 35.5885 162.668 31.6719 161.501 27.6719C159.418 20.5052 153.585 14.6719 146.501 12.5885C142.501 11.4219 138.585 11.4219 135.001 12.1719C128.751 13.5885 122.418 10.7552 118.918 5.33854C117.001 2.33854 114.251 -0.328125 110.668 -2.32813C104.168 -5.91146 95.918 -5.91146 89.418 -2.32813C85.8346 -0.328125 83.0846 2.33854 81.168 5.33854C77.668 10.6719 71.3346 13.5885 65.0846 12.1719C61.5013 11.3385 57.5846 11.4219 53.5846 12.5885C46.418 14.6719 40.5846 20.5052 38.5846 27.6719C37.418 31.6719 37.3346 35.5885 38.168 39.1719C39.5846 45.4219 36.7513 51.7552 31.3346 55.2552C28.3346 57.1719 25.668 59.9219 23.668 63.5052C21.8346 66.7552 20.918 70.5052 21.0013 74.2552C21.0013 78.0052 21.8346 81.6719 23.668 85.0052C25.668 88.5885 28.3346 91.3385 31.3346 93.2552C36.668 96.7552 39.5846 103.089 38.168 109.339C37.3346 112.922 37.418 116.839 38.5846 120.839C40.668 128.005 46.5013 133.839 53.5846 135.922C57.5846 137.089 61.5013 137.089 65.0846 136.339C71.3346 134.922 77.668 137.755 81.168 143.172C83.0846 146.172 85.8346 148.839 89.418 150.839C95.918 154.422 104.168 154.422 110.668 150.839C114.251 148.839 117.001 146.172 118.918 143.172C122.418 137.839 128.751 134.922 135.001 136.339C138.585 137.172 142.501 137.089 146.501 135.922C153.668 133.839 159.501 128.005 161.501 120.839C162.668 116.839 162.751 112.922 161.918 109.339C160.501 103.089 163.335 96.7552 168.751 93.2552C171.751 91.3385 174.418 88.5885 176.418 85.0052C178.251 81.7552 179.168 78.0052 179.085 74.2552C179.085 70.5052 178.168 66.8385 176.418 63.5052ZM125.085 108.922H76.5846V94.0052H92.0846V58.5885L80.2513 65.3385L73.5846 52.0052L97.5846 38.4219H110.585V94.0052H125.085V108.922Z"
            fill="#F1E8BB"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_4712">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
};

export const SilverAwardIcon = () => {
  const { mode } = useContext(ThemeContext);

  if (mode === "dark") {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_8002)">
          <path
            d="M197.751 148.168L177.501 127.918C173.335 139.418 163.668 148.501 151.835 151.918C145.668 153.668 139.335 154.001 133.251 152.835C130.751 156.501 127.751 159.668 124.168 162.335L153.918 192.085C156.585 194.835 160.751 195.751 164.418 194.501C165.835 194.001 167.168 193.168 168.251 192.085C169.835 190.501 170.918 188.335 171.168 185.918L173.168 167.501L191.668 165.418C197.251 164.835 201.251 159.835 200.668 154.251C200.418 152.001 199.418 149.835 197.751 148.168Z"
            fill="#324E58"
          />
          <path
            d="M68.1685 152.751C62.0851 153.917 55.6685 153.667 49.5851 151.834C37.7518 148.417 28.0851 139.334 23.9185 127.834L3.66846 148.084C2.08513 149.667 1.00179 151.834 0.751793 154.167C0.168459 159.751 4.16846 164.751 9.75179 165.334L28.2518 167.417L30.3351 185.834C30.5851 188.167 31.5851 190.334 33.2518 192.001C34.3351 193.084 35.5851 193.917 37.0851 194.417C40.7518 195.751 44.9185 194.751 47.5851 192.001L77.3351 162.251C73.7518 159.584 70.7518 156.417 68.2518 152.751H68.1685Z"
            fill="#324E58"
          />
          <path
            d="M177.086 63.4993C175.086 59.916 172.419 57.166 169.419 55.2493C164.086 51.7493 161.169 45.416 162.586 39.166C163.419 35.5827 163.336 31.666 162.169 27.666C160.086 20.4993 154.253 14.666 147.169 12.5827C143.169 11.416 139.253 11.416 135.669 12.166C129.419 13.5827 123.086 10.7493 119.586 5.33268C117.669 2.33268 114.919 -0.333985 111.336 -2.33398C104.836 -5.91732 96.5859 -5.91732 90.0859 -2.33398C86.5026 -0.333985 83.7526 2.33268 81.8359 5.33268C78.3359 10.666 72.0026 13.5827 65.7526 12.166C62.1693 11.3327 58.2526 11.416 54.2526 12.5827C47.0859 14.666 41.2526 20.4993 39.2526 27.666C38.0859 31.666 38.0026 35.5827 38.8359 39.166C40.2526 45.416 37.4193 51.7493 32.0026 55.2493C29.0026 57.166 26.3359 59.916 24.3359 63.4993C22.5026 66.7493 21.5859 70.4993 21.6693 74.2493C21.6693 77.9993 22.5026 81.666 24.3359 84.9993C26.3359 88.5827 29.0026 91.3327 32.0026 93.2493C37.3359 96.7493 40.2526 103.083 38.8359 109.333C38.0026 112.916 38.0859 116.833 39.2526 120.833C41.3359 127.999 47.1693 133.833 54.2526 135.916C58.2526 137.083 62.1693 137.083 65.7526 136.333C72.0026 134.916 78.3359 137.749 81.8359 143.166C83.7526 146.166 86.5026 148.833 90.0859 150.833C96.5859 154.416 104.836 154.416 111.336 150.833C114.919 148.833 117.669 146.166 119.586 143.166C123.086 137.833 129.419 134.916 135.669 136.333C139.253 137.166 143.169 137.083 147.169 135.916C154.336 133.833 160.169 127.999 162.169 120.833C163.336 116.833 163.419 112.916 162.586 109.333C161.169 103.083 164.003 96.7493 169.419 93.2493C172.419 91.3327 175.086 88.5827 177.086 84.9993C178.919 81.7493 179.836 77.9993 179.753 74.2493C179.753 70.4993 178.836 66.8327 177.086 63.4993ZM128.586 108.916H79.5026V95.416L100.669 73.2493C102.503 71.416 103.919 69.666 105.003 68.166C106.086 66.666 106.836 65.2493 107.336 63.9993C107.836 62.666 108.003 61.416 108.003 60.0827C108.003 57.5827 107.169 55.666 105.503 54.3327C103.836 52.9993 101.419 52.416 98.1693 52.416C95.5859 52.416 92.9193 52.916 90.0859 53.916C87.3359 54.916 84.5859 56.4993 81.8359 58.7493L76.1693 45.2493C79.2526 42.8327 82.9193 40.916 87.3359 39.4993C91.6693 38.0827 96.2526 37.3327 100.919 37.3327C106.419 37.3327 111.003 38.166 114.669 39.7493C118.336 41.3327 121.169 43.666 123.086 46.8327C125.003 49.916 126.003 53.666 126.003 57.9993C126.003 60.166 125.753 62.2493 125.336 64.3327C124.919 66.416 124.169 68.416 123.169 70.416C122.169 72.416 120.836 74.416 119.253 76.4993C117.669 78.5827 115.753 80.7493 113.419 82.9993L102.003 94.3327H128.669V109.249L128.586 108.916Z"
            fill="#324E58"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_8002">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0.667969 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width="188"
        height="190"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_4717)">
          <path
            d="M197.419 148.168L177.169 127.918C173.003 139.418 163.336 148.501 151.503 151.918C145.336 153.668 139.003 154.001 132.919 152.835C130.419 156.501 127.419 159.668 123.836 162.335L153.586 192.085C156.253 194.835 160.419 195.751 164.086 194.501C165.503 194.001 166.836 193.168 167.919 192.085C169.503 190.501 170.586 188.335 170.836 185.918L172.836 167.501L191.336 165.418C196.919 164.835 200.919 159.835 200.336 154.251C200.086 152.001 199.086 149.835 197.419 148.168Z"
            fill="#EAEAEA"
          />
          <path
            d="M67.8364 152.751C61.7531 153.917 55.3364 153.667 49.2531 151.834C37.4198 148.417 27.7531 139.334 23.5864 127.834L3.33643 148.084C1.75309 149.667 0.669761 151.834 0.419761 154.167C-0.163572 159.751 3.83643 164.751 9.41976 165.334L27.9198 167.417L30.0031 185.834C30.2531 188.167 31.2531 190.334 32.9198 192.001C34.0031 193.084 35.2531 193.917 36.7531 194.417C40.4198 195.751 44.5864 194.751 47.2531 192.001L77.0031 162.251C73.4198 159.584 70.4198 156.417 67.9198 152.751H67.8364Z"
            fill="#EAEAEA"
          />
          <path
            d="M176.754 63.4993C174.754 59.916 172.087 57.166 169.087 55.2493C163.754 51.7493 160.837 45.416 162.254 39.166C163.087 35.5827 163.004 31.666 161.837 27.666C159.754 20.4993 153.921 14.666 146.837 12.5827C142.837 11.416 138.921 11.416 135.337 12.166C129.087 13.5827 122.754 10.7493 119.254 5.33268C117.337 2.33268 114.587 -0.333985 111.004 -2.33398C104.504 -5.91732 96.2539 -5.91732 89.7539 -2.33398C86.1706 -0.333985 83.4206 2.33268 81.5039 5.33268C78.0039 10.666 71.6706 13.5827 65.4206 12.166C61.8372 11.3327 57.9206 11.416 53.9206 12.5827C46.7539 14.666 40.9206 20.4993 38.9206 27.666C37.7539 31.666 37.6706 35.5827 38.5039 39.166C39.9206 45.416 37.0872 51.7493 31.6706 55.2493C28.6706 57.166 26.0039 59.916 24.0039 63.4993C22.1706 66.7493 21.2539 70.4993 21.3372 74.2493C21.3372 77.9993 22.1706 81.666 24.0039 84.9993C26.0039 88.5827 28.6706 91.3327 31.6706 93.2493C37.0039 96.7493 39.9206 103.083 38.5039 109.333C37.6706 112.916 37.7539 116.833 38.9206 120.833C41.0039 127.999 46.8372 133.833 53.9206 135.916C57.9206 137.083 61.8372 137.083 65.4206 136.333C71.6706 134.916 78.0039 137.749 81.5039 143.166C83.4206 146.166 86.1706 148.833 89.7539 150.833C96.2539 154.416 104.504 154.416 111.004 150.833C114.587 148.833 117.337 146.166 119.254 143.166C122.754 137.833 129.087 134.916 135.337 136.333C138.921 137.166 142.837 137.083 146.837 135.916C154.004 133.833 159.837 127.999 161.837 120.833C163.004 116.833 163.087 112.916 162.254 109.333C160.837 103.083 163.671 96.7493 169.087 93.2493C172.087 91.3327 174.754 88.5827 176.754 84.9993C178.587 81.7493 179.504 77.9993 179.421 74.2493C179.421 70.4993 178.504 66.8327 176.754 63.4993ZM128.254 108.916H79.1706V95.416L100.337 73.2493C102.171 71.416 103.587 69.666 104.671 68.166C105.754 66.666 106.504 65.2493 107.004 63.9993C107.504 62.666 107.671 61.416 107.671 60.0827C107.671 57.5827 106.837 55.666 105.171 54.3327C103.504 52.9993 101.087 52.416 97.8372 52.416C95.2539 52.416 92.5872 52.916 89.7539 53.916C87.0039 54.916 84.2539 56.4993 81.5039 58.7493L75.8372 45.2493C78.9206 42.8327 82.5872 40.916 87.0039 39.4993C91.3372 38.0827 95.9206 37.3327 100.587 37.3327C106.087 37.3327 110.671 38.166 114.337 39.7493C118.004 41.3327 120.837 43.666 122.754 46.8327C124.671 49.916 125.671 53.666 125.671 57.9993C125.671 60.166 125.421 62.2493 125.004 64.3327C124.587 66.416 123.837 68.416 122.837 70.416C121.837 72.416 120.504 74.416 118.921 76.4993C117.337 78.5827 115.421 80.7493 113.087 82.9993L101.671 94.3327H128.337V109.249L128.254 108.916Z"
            fill="#EAEAEA"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_4717">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0.335938 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
};

export const BronzeAwardIcon = () => {
  const { mode } = useContext(ThemeContext);

  if (mode === "dark") {
    return (
      <svg
        width="188"
        height="190"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_8438)">
          <path
            d="M197.415 148.168L177.165 127.918C172.999 139.418 163.332 148.501 151.499 151.918C145.332 153.668 138.999 154.001 132.915 152.835C130.415 156.501 127.415 159.668 123.832 162.335L153.582 192.085C156.249 194.835 160.415 195.751 164.082 194.501C165.499 194.001 166.832 193.168 167.915 192.085C169.499 190.501 170.582 188.335 170.832 185.918L172.832 167.501L191.332 165.418C196.915 164.835 200.915 159.835 200.332 154.251C200.082 152.001 199.082 149.835 197.415 148.168Z"
            fill="#354848"
          />
          <path
            d="M67.8325 152.751C61.7492 153.917 55.3325 153.667 49.2492 151.834C37.4159 148.417 27.7492 139.334 23.5825 127.834L3.33252 148.084C1.74919 149.667 0.665855 151.834 0.415855 154.167C-0.167478 159.751 3.83252 164.751 9.41586 165.334L27.9159 167.417L29.9992 185.834C30.2492 188.167 31.2492 190.334 32.9159 192.001C33.9992 193.084 35.2492 193.917 36.7492 194.417C40.4159 195.751 44.5825 194.751 47.2492 192.001L76.9992 162.251C73.4158 159.584 70.4158 156.417 67.9158 152.751H67.8325Z"
            fill="#354848"
          />
          <path
            d="M176.75 63.4993C174.75 59.916 172.083 57.166 169.083 55.2493C163.75 51.7493 160.833 45.416 162.25 39.166C163.083 35.5827 163 31.666 161.833 27.666C159.75 20.4993 153.917 14.666 146.833 12.5827C142.833 11.416 138.917 11.416 135.333 12.166C129.083 13.5827 122.75 10.7493 119.25 5.33268C117.333 2.33268 114.583 -0.333985 111 -2.33398C104.5 -5.91732 96.25 -5.91732 89.75 -2.33398C86.1667 -0.333985 83.4167 2.33268 81.5 5.33268C78 10.666 71.6667 13.5827 65.4167 12.166C61.8333 11.3327 57.9167 11.416 53.9167 12.5827C46.75 14.666 40.9167 20.4993 38.9167 27.666C37.75 31.666 37.6667 35.5827 38.5 39.166C39.9167 45.416 37.0833 51.7493 31.6667 55.2493C28.6667 57.166 26 59.916 24 63.4993C22.1667 66.7493 21.25 70.4993 21.3333 74.2493C21.3333 77.9993 22.1667 81.666 24 84.9993C26 88.5827 28.6667 91.3327 31.6667 93.2493C37 96.7493 39.9167 103.083 38.5 109.333C37.6667 112.916 37.75 116.833 38.9167 120.833C41 127.999 46.8333 133.833 53.9167 135.916C57.9167 137.083 61.8333 137.083 65.4167 136.333C71.6667 134.916 78 137.749 81.5 143.166C83.4167 146.166 86.1667 148.833 89.75 150.833C96.25 154.416 104.5 154.416 111 150.833C114.583 148.833 117.333 146.166 119.25 143.166C122.75 137.833 129.083 134.916 135.333 136.333C138.917 137.166 142.833 137.083 146.833 135.916C154 133.833 159.833 127.999 161.833 120.833C163 116.833 163.083 112.916 162.25 109.333C160.833 103.083 163.667 96.7493 169.083 93.2493C172.083 91.3327 174.75 88.5827 176.75 84.9993C178.583 81.7493 179.5 77.9993 179.417 74.2493C179.417 70.4993 178.5 66.8327 176.75 63.4993ZM126.083 100.333C123.917 103.416 120.75 105.833 116.583 107.499C112.417 109.166 107.5 110.083 101.75 110.083C98.4167 110.083 95.1667 109.749 91.9167 109.166C88.6667 108.583 85.75 107.666 83.0833 106.499C80.4167 105.333 78.0833 103.999 76.25 102.416L81.8333 88.8327C84.75 90.8327 87.8333 92.3327 91.0833 93.416C94.3333 94.4993 97.6667 94.9993 101.167 94.9993C103.5 94.9993 105.5 94.7493 107.083 94.166C108.667 93.5827 109.917 92.7493 110.667 91.5827C111.5 90.416 111.833 89.0827 111.833 87.4993C111.833 85.166 111 83.416 109.417 82.3327C107.833 81.2493 105.417 80.666 102.25 80.666H89.9167V66.166H100.5C102.333 66.166 104 65.916 105.333 65.3327C106.667 64.8327 107.75 63.9993 108.5 62.916C109.25 61.8327 109.667 60.5827 109.667 59.0827C109.667 56.916 108.833 55.166 107.25 53.9993C105.667 52.8327 103.25 52.166 100.167 52.166C97.0833 52.166 94.0833 52.666 91.25 53.7493C88.4167 54.8327 85.6667 56.3327 83 58.4993L77.4167 44.9993C80.4167 42.4993 84.0833 40.5827 88.5 39.166C92.8333 37.7493 97.4167 37.0827 102.083 37.0827C107.417 37.0827 111.917 37.8327 115.667 39.416C119.417 40.9993 122.25 43.2493 124.25 46.0827C126.25 48.916 127.25 52.4993 127.25 56.4993C127.25 60.4994 126.083 64.0827 123.833 66.916C122 69.2493 119.417 70.8327 116.417 71.916C118.667 72.4993 120.75 73.3327 122.5 74.5827C124.667 76.166 126.417 78.166 127.583 80.666C128.75 83.0827 129.417 85.916 129.417 89.0827C129.417 93.3327 128.333 96.9993 126.083 100.166V100.333Z"
            fill="#354848"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_8438">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0.332031 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 188 190"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_309_4727)">
          <path
            d="M197.747 148.168L177.497 127.918C173.331 139.418 163.664 148.501 151.831 151.918C145.664 153.668 139.331 154.001 133.247 152.835C130.747 156.501 127.747 159.668 124.164 162.335L153.914 192.085C156.581 194.835 160.747 195.751 164.414 194.501C165.831 194.001 167.164 193.168 168.247 192.085C169.831 190.501 170.914 188.335 171.164 185.918L173.164 167.501L191.664 165.418C197.247 164.835 201.247 159.835 200.664 154.251C200.414 152.001 199.414 149.835 197.747 148.168Z"
            fill="#F2E3CF"
          />
          <path
            d="M68.1646 152.751C62.0812 153.917 55.6646 153.667 49.5812 151.834C37.7479 148.417 28.0812 139.334 23.9146 127.834L3.66455 148.084C2.08122 149.667 0.997886 151.834 0.747886 154.167C0.164553 159.751 4.16455 164.751 9.74789 165.334L28.2479 167.417L30.3312 185.834C30.5812 188.167 31.5812 190.334 33.2479 192.001C34.3312 193.084 35.5812 193.917 37.0812 194.417C40.7479 195.751 44.9146 194.751 47.5812 192.001L77.3312 162.251C73.7479 159.584 70.7479 156.417 68.2479 152.751H68.1646Z"
            fill="#F2E3CF"
          />
          <path
            d="M177.082 63.4993C175.082 59.916 172.415 57.166 169.415 55.2493C164.082 51.7493 161.165 45.416 162.582 39.166C163.415 35.5827 163.332 31.666 162.165 27.666C160.082 20.4993 154.249 14.666 147.165 12.5827C143.165 11.416 139.249 11.416 135.665 12.166C129.415 13.5827 123.082 10.7493 119.582 5.33268C117.665 2.33268 114.915 -0.333985 111.332 -2.33398C104.832 -5.91732 96.582 -5.91732 90.082 -2.33398C86.4987 -0.333985 83.7487 2.33268 81.832 5.33268C78.332 10.666 71.9987 13.5827 65.7487 12.166C62.1654 11.3327 58.2487 11.416 54.2487 12.5827C47.082 14.666 41.2487 20.4993 39.2487 27.666C38.082 31.666 37.9987 35.5827 38.832 39.166C40.2487 45.416 37.4154 51.7493 31.9987 55.2493C28.9987 57.166 26.332 59.916 24.332 63.4993C22.4987 66.7493 21.582 70.4993 21.6654 74.2493C21.6654 77.9993 22.4987 81.666 24.332 84.9993C26.332 88.5827 28.9987 91.3327 31.9987 93.2493C37.332 96.7493 40.2487 103.083 38.832 109.333C37.9987 112.916 38.082 116.833 39.2487 120.833C41.332 127.999 47.1654 133.833 54.2487 135.916C58.2487 137.083 62.1654 137.083 65.7487 136.333C71.9987 134.916 78.332 137.749 81.832 143.166C83.7487 146.166 86.4987 148.833 90.082 150.833C96.582 154.416 104.832 154.416 111.332 150.833C114.915 148.833 117.665 146.166 119.582 143.166C123.082 137.833 129.415 134.916 135.665 136.333C139.249 137.166 143.165 137.083 147.165 135.916C154.332 133.833 160.165 127.999 162.165 120.833C163.332 116.833 163.415 112.916 162.582 109.333C161.165 103.083 163.999 96.7493 169.415 93.2493C172.415 91.3327 175.082 88.5827 177.082 84.9993C178.915 81.7493 179.832 77.9993 179.749 74.2493C179.749 70.4993 178.832 66.8327 177.082 63.4993ZM126.415 100.333C124.249 103.416 121.082 105.833 116.915 107.499C112.749 109.166 107.832 110.083 102.082 110.083C98.7487 110.083 95.4987 109.749 92.2487 109.166C88.9987 108.583 86.082 107.666 83.4154 106.499C80.7487 105.333 78.4154 103.999 76.582 102.416L82.1654 88.8327C85.082 90.8327 88.1654 92.3327 91.4154 93.416C94.6654 94.4993 97.9987 94.9993 101.499 94.9993C103.832 94.9993 105.832 94.7493 107.415 94.166C108.999 93.5827 110.249 92.7493 110.999 91.5827C111.832 90.416 112.165 89.0827 112.165 87.4993C112.165 85.166 111.332 83.416 109.749 82.3327C108.165 81.2493 105.749 80.666 102.582 80.666H90.2487V66.166H100.832C102.665 66.166 104.332 65.916 105.665 65.3327C106.999 64.8327 108.082 63.9993 108.832 62.916C109.582 61.8327 109.999 60.5827 109.999 59.0827C109.999 56.916 109.165 55.166 107.582 53.9993C105.999 52.8327 103.582 52.166 100.499 52.166C97.4154 52.166 94.4154 52.666 91.582 53.7493C88.7487 54.8327 85.9987 56.3327 83.332 58.4993L77.7487 44.9993C80.7487 42.4993 84.4154 40.5827 88.832 39.166C93.1654 37.7493 97.7487 37.0827 102.415 37.0827C107.749 37.0827 112.249 37.8327 115.999 39.416C119.749 40.9993 122.582 43.2493 124.582 46.0827C126.582 48.916 127.582 52.4993 127.582 56.4993C127.582 60.4994 126.415 64.0827 124.165 66.916C122.332 69.2493 119.749 70.8327 116.749 71.916C118.999 72.4993 121.082 73.3327 122.832 74.5827C124.999 76.166 126.749 78.166 127.915 80.666C129.082 83.0827 129.749 85.916 129.749 89.0827C129.749 93.3327 128.665 96.9993 126.415 100.166V100.333Z"
            fill="#F2E3CF"
          />
        </g>
        <defs>
          <clipPath id="clip0_309_4727">
            <rect
              width="200"
              height="200"
              fill="white"
              transform="translate(0.664062 -5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
};

export const AddFavoriteToFolderIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id="AddFavoriteToFolderIcon"
    >
      <svg
        width="22px"
        height="22px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 14H12M12 14H14M12 14V16M12 14V12"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M22 11.7979C22 9.16554 22 7.84935 21.2305 6.99383C21.1598 6.91514 21.0849 6.84024 21.0062 6.76946C20.1506 6 18.8345 6 16.2021 6H15.8284C14.6747 6 14.0979 6 13.5604 5.84678C13.2651 5.7626 12.9804 5.64471 12.7121 5.49543C12.2237 5.22367 11.8158 4.81578 11 4L10.4497 3.44975C10.1763 3.17633 10.0396 3.03961 9.89594 2.92051C9.27652 2.40704 8.51665 2.09229 7.71557 2.01738C7.52976 2 7.33642 2 6.94975 2C6.06722 2 5.62595 2 5.25839 2.06935C3.64031 2.37464 2.37464 3.64031 2.06935 5.25839C2 5.62595 2 6.06722 2 6.94975M21.9913 16C21.9554 18.4796 21.7715 19.8853 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V11"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>

      <Tooltip id={"AddFavoriteToFolderIcon"} content={"Select folder"} />
    </span>
  );
};

export const FolderFilledIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6px"
      height="6px"
      viewBox="0 0 20 20"
      version="1.1"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-220.000000, -1199.000000)"
          fill={color}
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M184,1045.0005 L184,1057.0005 C184,1058.1055 183.105,1059.0005 182,1059.0005 L166,1059.0005 C164.895,1059.0005 164,1058.1055 164,1057.0005 L164,1041.0005 C164,1039.8955 164.895,1039.0005 166,1039.0005 L172,1039.0005 C173.105,1039.0005 174,1039.8955 174,1041.0005 L174,1042.0005 C174,1042.5525 174.448,1043.0005 175,1043.0005 L182,1043.0005 C183.105,1043.0005 184,1043.8955 184,1045.0005"
              id="folder_fill-[#1777]"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SettingsIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id="SettingsIconIcon"
    >
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8.25C9.92894 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92894 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9747 1.25C11.5303 1.24999 11.1592 1.24999 10.8546 1.27077C10.5375 1.29241 10.238 1.33905 9.94761 1.45933C9.27379 1.73844 8.73843 2.27379 8.45932 2.94762C8.31402 3.29842 8.27467 3.66812 8.25964 4.06996C8.24756 4.39299 8.08454 4.66251 7.84395 4.80141C7.60337 4.94031 7.28845 4.94673 7.00266 4.79568C6.64714 4.60777 6.30729 4.45699 5.93083 4.40743C5.20773 4.31223 4.47642 4.50819 3.89779 4.95219C3.64843 5.14353 3.45827 5.3796 3.28099 5.6434C3.11068 5.89681 2.92517 6.21815 2.70294 6.60307L2.67769 6.64681C2.45545 7.03172 2.26993 7.35304 2.13562 7.62723C1.99581 7.91267 1.88644 8.19539 1.84541 8.50701C1.75021 9.23012 1.94617 9.96142 2.39016 10.5401C2.62128 10.8412 2.92173 11.0602 3.26217 11.2741C3.53595 11.4461 3.68788 11.7221 3.68786 12C3.68785 12.2778 3.53592 12.5538 3.26217 12.7258C2.92169 12.9397 2.62121 13.1587 2.39007 13.4599C1.94607 14.0385 1.75012 14.7698 1.84531 15.4929C1.88634 15.8045 1.99571 16.0873 2.13552 16.3727C2.26983 16.6469 2.45535 16.9682 2.67758 17.3531L2.70284 17.3969C2.92507 17.7818 3.11058 18.1031 3.28089 18.3565C3.45817 18.6203 3.64833 18.8564 3.89769 19.0477C4.47632 19.4917 5.20763 19.6877 5.93073 19.5925C6.30717 19.5429 6.647 19.3922 7.0025 19.2043C7.28833 19.0532 7.60329 19.0596 7.8439 19.1986C8.08452 19.3375 8.24756 19.607 8.25964 19.9301C8.27467 20.3319 8.31403 20.7016 8.45932 21.0524C8.73843 21.7262 9.27379 22.2616 9.94761 22.5407C10.238 22.661 10.5375 22.7076 10.8546 22.7292C11.1592 22.75 11.5303 22.75 11.9747 22.75H12.0252C12.4697 22.75 12.8407 22.75 13.1454 22.7292C13.4625 22.7076 13.762 22.661 14.0524 22.5407C14.7262 22.2616 15.2616 21.7262 15.5407 21.0524C15.686 20.7016 15.7253 20.3319 15.7403 19.93C15.7524 19.607 15.9154 19.3375 16.156 19.1985C16.3966 19.0596 16.7116 19.0532 16.9974 19.2042C17.3529 19.3921 17.6927 19.5429 18.0692 19.5924C18.7923 19.6876 19.5236 19.4917 20.1022 19.0477C20.3516 18.8563 20.5417 18.6203 20.719 18.3565C20.8893 18.1031 21.0748 17.7818 21.297 17.3969L21.3223 17.3531C21.5445 16.9682 21.7301 16.6468 21.8644 16.3726C22.0042 16.0872 22.1135 15.8045 22.1546 15.4929C22.2498 14.7697 22.0538 14.0384 21.6098 13.4598C21.3787 13.1586 21.0782 12.9397 20.7378 12.7258C20.464 12.5538 20.3121 12.2778 20.3121 11.9999C20.3121 11.7221 20.464 11.4462 20.7377 11.2742C21.0783 11.0603 21.3788 10.8414 21.6099 10.5401C22.0539 9.96149 22.2499 9.23019 22.1547 8.50708C22.1136 8.19546 22.0043 7.91274 21.8645 7.6273C21.7302 7.35313 21.5447 7.03183 21.3224 6.64695L21.2972 6.60318C21.0749 6.21825 20.8894 5.89688 20.7191 5.64347C20.5418 5.37967 20.3517 5.1436 20.1023 4.95225C19.5237 4.50826 18.7924 4.3123 18.0692 4.4075C17.6928 4.45706 17.353 4.60782 16.9975 4.79572C16.7117 4.94679 16.3967 4.94036 16.1561 4.80144C15.9155 4.66253 15.7524 4.39297 15.7403 4.06991C15.7253 3.66808 15.686 3.2984 15.5407 2.94762C15.2616 2.27379 14.7262 1.73844 14.0524 1.45933C13.762 1.33905 13.4625 1.29241 13.1454 1.27077C12.8407 1.24999 12.4697 1.24999 12.0252 1.25H11.9747ZM10.5216 2.84515C10.5988 2.81319 10.716 2.78372 10.9567 2.76729C11.2042 2.75041 11.5238 2.75 12 2.75C12.4762 2.75 12.7958 2.75041 13.0432 2.76729C13.284 2.78372 13.4012 2.81319 13.4783 2.84515C13.7846 2.97202 14.028 3.21536 14.1548 3.52165C14.1949 3.61826 14.228 3.76887 14.2414 4.12597C14.271 4.91835 14.68 5.68129 15.4061 6.10048C16.1321 6.51968 16.9974 6.4924 17.6984 6.12188C18.0143 5.9549 18.1614 5.90832 18.265 5.89467C18.5937 5.8514 18.9261 5.94047 19.1891 6.14228C19.2554 6.19312 19.3395 6.27989 19.4741 6.48016C19.6125 6.68603 19.7726 6.9626 20.0107 7.375C20.2488 7.78741 20.4083 8.06438 20.5174 8.28713C20.6235 8.50382 20.6566 8.62007 20.6675 8.70287C20.7108 9.03155 20.6217 9.36397 20.4199 9.62698C20.3562 9.70995 20.2424 9.81399 19.9397 10.0041C19.2684 10.426 18.8122 11.1616 18.8121 11.9999C18.8121 12.8383 19.2683 13.574 19.9397 13.9959C20.2423 14.186 20.3561 14.29 20.4198 14.373C20.6216 14.636 20.7107 14.9684 20.6674 15.2971C20.6565 15.3799 20.6234 15.4961 20.5173 15.7128C20.4082 15.9355 20.2487 16.2125 20.0106 16.6249C19.7725 17.0373 19.6124 17.3139 19.474 17.5198C19.3394 17.72 19.2553 17.8068 19.189 17.8576C18.926 18.0595 18.5936 18.1485 18.2649 18.1053C18.1613 18.0916 18.0142 18.045 17.6983 17.8781C16.9973 17.5075 16.132 17.4803 15.4059 17.8995C14.68 18.3187 14.271 19.0816 14.2414 19.874C14.228 20.2311 14.1949 20.3817 14.1548 20.4784C14.028 20.7846 13.7846 21.028 13.4783 21.1549C13.4012 21.1868 13.284 21.2163 13.0432 21.2327C12.7958 21.2496 12.4762 21.25 12 21.25C11.5238 21.25 11.2042 21.2496 10.9567 21.2327C10.716 21.2163 10.5988 21.1868 10.5216 21.1549C10.2154 21.028 9.97201 20.7846 9.84514 20.4784C9.80512 20.3817 9.77195 20.2311 9.75859 19.874C9.72896 19.0817 9.31997 18.3187 8.5939 17.8995C7.86784 17.4803 7.00262 17.5076 6.30158 17.8781C5.98565 18.0451 5.83863 18.0917 5.73495 18.1053C5.40626 18.1486 5.07385 18.0595 4.81084 17.8577C4.74458 17.8069 4.66045 17.7201 4.52586 17.5198C4.38751 17.314 4.22736 17.0374 3.98926 16.625C3.75115 16.2126 3.59171 15.9356 3.4826 15.7129C3.37646 15.4962 3.34338 15.3799 3.33248 15.2971C3.28921 14.9684 3.37828 14.636 3.5801 14.373C3.64376 14.2901 3.75761 14.186 4.0602 13.9959C4.73158 13.5741 5.18782 12.8384 5.18786 12.0001C5.18791 11.1616 4.73165 10.4259 4.06021 10.004C3.75769 9.81389 3.64385 9.70987 3.58019 9.62691C3.37838 9.3639 3.28931 9.03149 3.33258 8.7028C3.34348 8.62001 3.37656 8.50375 3.4827 8.28707C3.59181 8.06431 3.75125 7.78734 3.98935 7.37493C4.22746 6.96253 4.3876 6.68596 4.52596 6.48009C4.66055 6.27983 4.74468 6.19305 4.81093 6.14222C5.07395 5.9404 5.40636 5.85133 5.73504 5.8946C5.83873 5.90825 5.98576 5.95483 6.30173 6.12184C7.00273 6.49235 7.86791 6.51962 8.59394 6.10045C9.31998 5.68128 9.72896 4.91837 9.75859 4.12602C9.77195 3.76889 9.80512 3.61827 9.84514 3.52165C9.97201 3.21536 10.2154 2.97202 10.5216 2.84515Z"
          fill={color}
        />
      </svg>

      <Tooltip id={"SettingsIconIcon"} content={"Open Settings"} />
    </span>
  );
};

export const DeleteBinIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id="DeleteBinIconIcon"
    >
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 12V17"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 12V17"
          stroke={color}
          strokeWidth="1"
          strokLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 7H20"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <Tooltip id={"DeleteBinIconIcon"} content={"Delete"} />
    </span>
  );
};

export const EditIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative cursor-pointer" data-tooltip-id="EditIconIcon">
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 10L21 7L17 3L14 6M18 10L8 20H4V16L14 6M18 10L14 6"
          stroke={color}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <Tooltip id={"EditIconIcon"} content={"Edit"} />
    </span>
  );
};

export const SaveIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative cursor-pointer" data-tooltip-id="SaveIconIcon">
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Icon-Set"
            transform="translate(-152.000000, -515.000000)"
            fill={color}
          >
            <path
              d="M171,525 C171.552,525 172,524.553 172,524 L172,520 C172,519.447 171.552,519 171,519 C170.448,519 170,519.447 170,520 L170,524 C170,524.553 170.448,525 171,525 L171,525 Z M182,543 C182,544.104 181.104,545 180,545 L156,545 C154.896,545 154,544.104 154,543 L154,519 C154,517.896 154.896,517 156,517 L158,517 L158,527 C158,528.104 158.896,529 160,529 L176,529 C177.104,529 178,528.104 178,527 L178,517 L180,517 C181.104,517 182,517.896 182,519 L182,543 L182,543 Z M160,517 L176,517 L176,526 C176,526.553 175.552,527 175,527 L161,527 C160.448,527 160,526.553 160,526 L160,517 L160,517 Z M180,515 L156,515 C153.791,515 152,516.791 152,519 L152,543 C152,545.209 153.791,547 156,547 L180,547 C182.209,547 184,545.209 184,543 L184,519 C184,516.791 182.209,515 180,515 L180,515 Z"
              id="save-floppy"
            ></path>
          </g>
        </g>
      </svg>

      <Tooltip id={"SaveIconIcon"} content={"Save"} />
    </span>
  );
};

export const CancelIcon = () => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span className="relative cursor-pointer" data-tooltip-id="CancelIconIcon">
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="9" stroke={color} />
        <path d="M18 18L6 6" stroke={color} />
      </svg>

      <Tooltip id={"CancelIconIcon"} content={"Cancel"} />
    </span>
  );
};

export const SlackIcon = ({ tooltipText = "", tooltipId = "" }) => {
  const { mode } = useContext(ThemeContext);

  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id={`SlackIcon${tooltipId}`}
    >
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9495 12C22.5978 11.3647 23 10.4793 23 9.5C23 7.567 21.433 6 19.5 6C18.9632 6 18.4546 6.12085 18 6.33682V4.5C18 2.567 16.433 1 14.5 1C13.5207 1 12.6353 1.40223 12 2.05051C11.3647 1.40223 10.4793 1 9.5 1C7.567 1 6 2.567 6 4.5C6 5.0368 6.12085 5.54537 6.33682 6H4.5C2.567 6 1 7.567 1 9.5C1 10.4793 1.40223 11.3647 2.05051 12C1.40223 12.6353 1 13.5207 1 14.5C1 16.433 2.567 18 4.5 18C5.0368 18 5.54537 17.8792 6 17.6632V19.5C6 21.433 7.567 23 9.5 23C10.4793 23 11.3647 22.5978 12 21.9495C12.6353 22.5978 13.5207 23 14.5 23C16.433 23 18 21.433 18 19.5C18 18.9632 17.8792 18.4546 17.6632 18H19.5C21.433 18 23 16.433 23 14.5C23 13.5207 22.5978 12.6353 21.9495 12ZM9.5 3C10.3284 3 11 3.67157 11 4.5V6H9.5C8.67157 6 8 5.32843 8 4.5C8 3.67157 8.67157 3 9.5 3ZM13 4.5C13 3.67157 13.6716 3 14.5 3C15.3284 3 16 3.67157 16 4.5V11H13V4.5ZM11 11V8H4.5C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11H11ZM18 11H19.5C20.3284 11 21 10.3284 21 9.5C21 8.67157 20.3284 8 19.5 8C18.6716 8 18 8.67157 18 9.5V11ZM19.5 13H13V16H19.5C20.3284 16 21 15.3284 21 14.5C21 13.6716 20.3284 13 19.5 13ZM14.5 18H13V19.5C13 20.3284 13.6716 21 14.5 21C15.3284 21 16 20.3284 16 19.5C16 18.6716 15.3284 18 14.5 18ZM11 13H8V19.5C8 20.3284 8.67157 21 9.5 21C10.3284 21 11 20.3284 11 19.5V13ZM4.5 13H6V14.5C6 15.3284 5.32843 16 4.5 16C3.67157 16 3 15.3284 3 14.5C3 13.6716 3.67157 13 4.5 13Z"
          fill={color}
        />
      </svg>

      {tooltipText && tooltipId && (
        <Tooltip id={`SlackIcon${tooltipId}`} content={tooltipText} />
      )}
    </span>
  );
};

export const FilterIcon = ({ tooltipText = "", tooltipId = "" }) => {
  const { mode } = useContext(ThemeContext);
  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id={`FilterIcon${tooltipId}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
          fill={color}
        />
      </svg>

      {tooltipText && tooltipId && (
        <Tooltip id={`FilterIcon${tooltipId}`} content={tooltipText} />
      )}
    </span>
  );
};

export const InstallIcon = ({ tooltipText = "", tooltipId = "" }) => {
  const { mode } = useContext(ThemeContext);
  const color = mode === "dark" ? "#fff" : "#000";

  return (
    <span
      className="relative cursor-pointer"
      data-tooltip-id={`InstallIcon${tooltipId}`}
    >
      <svg
        height="25px"
        width="25px"
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <g>
          <path
            fill={color}
            d="M426.537,0H179.641c-22.243,0-40.376,18.175-40.376,40.401v129.603h25.221V69.106h277.206V424.46H164.485
		v-83.887h-25.221v131.034c0,22.192,18.133,40.392,40.376,40.392h246.896c22.192,0,40.375-18.2,40.375-40.392v-129.03V40.401
		C466.912,18.175,448.728,0,426.537,0z M303.08,478.495c-9.174,0-16.636-7.47-16.636-16.661c0-9.183,7.462-16.653,16.636-16.653
		c9.158,0,16.686,7.47,16.686,16.653C319.766,471.025,312.247,478.495,303.08,478.495z"
          />
          <polygon
            fill={color}
            points="225.739,335.774 358.778,255.289 225.739,174.804 225.739,221.11 45.088,221.11 45.088,289.468 
		225.739,289.468 	"
          />
        </g>
      </svg>

      {tooltipText && tooltipId && (
        <Tooltip id={`InstallIcon${tooltipId}`} content={tooltipText} />
      )}
    </span>
  );
};
